export enum StepStatus {
  Passed = 'passed',
  Active = 'active',
  NotPassed = 'notPassed',
  Neutral = 'neutral',
  Danger = 'danger',
}
